import { render, staticRenderFns } from "./createpressuremodal.vue?vue&type=template&id=2ebe7955&"
import script from "./createpressuremodal.vue?vue&type=script&lang=ts&"
export * from "./createpressuremodal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createpressuremodal.vue"
export default component.exports